import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  enableAdvanceSearch: false,
 modes: actionCodeMenus.map((item) => {
        return {
          id: item.key,
          name: item.name,
          iconName: item.icon,
          url: item.url,
          description: item.description,
          disabled: item.disabled,
          productionReady: item.productionReady,
        };
      }),
  settingsMode: false,
};

const operationURLS = {
  create: "tenantMaster/create",
  update: "tenantMaster/update",
  list: "tenantMaster/filteredList",
  delete: "tenantMaster/delete",
};

export { Attributes, operationURLS };
